/**
 * alerts domain (doc 01 A1.2 / A1.3). Function names + paths mirror the route
 * inventory verbatim: `acknowledge(id)` → `POST /api/alerts/:id/acknowledge`.
 * Types mirror the API's service views (mark for consolidation with the API's
 * exported zod schemas when they are published).
 */
import { get, post } from './transport.js';
/**
 * `GET /api/alerts`
 *
 * Needs `alerts:read` AND `directory:read`. The second is not redundant: an
 * alert's `title` and `description` name the worker they are about (the
 * RuleMatch content contract permits it, and the Tier-1 rules do it), and the
 * name is stored in the row rather than resolved per reader, so the route
 * refuses a caller who could not have read that name from the directory. A
 * principal holding only `alerts:read` gets a 403 naming `directory:read`, not
 * an empty list. (No SHIPPED role is in that position any more: `analyst` was
 * the one, and 1757290000000 removed its `alerts:read` rather than leave a
 * grant that opened nothing. The gate stands for directly-granted keys.)
 */
export function list(query = {}, options) {
    return get('/api/alerts', { ...options, query: { ...query } });
}
/** `GET /api/alerts/:id` — same pair of permissions as `list`. */
export function detail(id, options) {
    return get(`/api/alerts/${id}`, options);
}
/** `POST /api/alerts/:id/acknowledge` */
export function acknowledge(id, notes) {
    return post(`/api/alerts/${id}/acknowledge`, notes ? { notes } : {});
}
/** `POST /api/alerts/:id/assign` */
export function assign(id, userId, notes) {
    return post(`/api/alerts/${id}/assign`, { userId, ...(notes ? { notes } : {}) });
}
/** `POST /api/alerts/:id/resolve` — resolutionNotes required (doc 01 A1.2). */
export function resolve(id, resolutionNotes) {
    return post(`/api/alerts/${id}/resolve`, { resolutionNotes });
}
/** `POST /api/alerts/:id/escalate` */
export function escalate(id, reason, newSeverity) {
    return post(`/api/alerts/${id}/escalate`, {
        reason,
        ...(newSeverity ? { newSeverity } : {}),
    });
}
//# sourceMappingURL=alerts.js.map